import { useState } from 'react';
import { User, LogOut, Settings, CreditCard, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { UserProfile } from '../types';
import { NotificationCenter } from './NotificationCenter';

interface UserProfileDropdownProps {
  profile: UserProfile;
  onLogout: () => void;
  onSettings?: () => void;
  onDashboard?: () => void;
}

export function UserProfileDropdown({ profile, onLogout, onSettings, onDashboard }: UserProfileDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <div className="flex items-center space-x-4">
        {/* Notifications */}
        <NotificationCenter />

        {/* Profile Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <div className="bg-blue-100 rounded-full p-2">
            <User className="h-5 w-5 text-blue-600" />
          </div>
          <span className="font-medium text-gray-700">{profile.name}</span>
        </button>
      </div>

      {/* Profile Dropdown */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg py-2 z-50 border border-gray-200">
          <div className="px-4 py-2 border-b border-gray-200">
            <p className="font-medium text-gray-900">{profile.name}</p>
            <p className="text-sm text-gray-600">{profile.email}</p>
          </div>

          <div className="py-2">
            {onDashboard && (
              <button
                onClick={() => {
                  setIsOpen(false);
                  onDashboard();
                }}
                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors"
              >
                <Home className="h-5 w-5 mr-3 text-blue-600" />
                Dashboard
              </button>
            )}
            
            <Link
              to="/subscription"
              className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors"
              onClick={() => setIsOpen(false)}
            >
              <CreditCard className="h-5 w-5 mr-3 text-blue-600" />
              Subscription
            </Link>
            
            {onSettings && (
              <button
                onClick={() => {
                  setIsOpen(false);
                  onSettings();
                }}
                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors"
              >
                <Settings className="h-5 w-5 mr-3 text-blue-600" />
                Settings
              </button>
            )}
            
            <button
              onClick={() => {
                setIsOpen(false);
                onLogout();
              }}
              className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <LogOut className="h-5 w-5 mr-3 text-blue-600" />
              Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}